(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))
                && !(response.status === 404 && (response.config.url.indexOf('api/maintenance-setting') === 0))) {
                $rootScope.$emit('jotApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
